import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Output,
    input,
    signal,
    inject,
    computed,
    effect, DestroyRef, ChangeDetectorRef
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DotLoadingServices } from "../../../core/services/dot-loading.Services";
import { BuyerService } from "../../../services";

// BuyerData interface based on API response
interface BuyerData {
    buyerId: number;
    buyerName: string;
    buyerCode: string;
    buyerStatus: number;
}

@Component({
    selector: 'app-search-buyer',
    imports: [FormsModule],
    templateUrl: './search-buyer.component.html',
    standalone: true,
    styleUrl: './search-buyer.component.scss'
})
export class SearchBuyerComponent {
    private buyerService = inject(BuyerService);
    private dotLoadingServices = inject(DotLoadingServices);
    private elementRef = inject(ElementRef);
    private destroyRef = inject(DestroyRef);

    private cdr = inject(ChangeDetectorRef);
    buyerName = input<string | undefined>(undefined);
    buyerId = input<number | undefined>(undefined);
    required = input<boolean>(true);
    disabled = input<boolean>(false);

    @Output() selectedBuyerId = new EventEmitter<number>();

    isListVisible = signal<boolean>(false);
    filterValue = signal<string>('');
    searchParams = signal({
        buyerName: '',

    });

    buyers = computed(() => this.buyerService.all());
    selectedBuyer = computed(() => this.buyerService.active());

    constructor() {
        // Initialize search when component loads with existing buyerId
        effect(() => {
            const id = this.buyerId();
            if (id && id > 0) {
                // this.buyerService.getById(id.toString()).subscribe({
                //     next: () => this.isListVisible.set(false),
                //     error: (error) => console.error('Error fetching buyer:', error)
                // });
            }
        });

        // Update filter value when selected buyer changes
        effect(() => {
            const selected = this.selectedBuyer();
            if (selected?.buyerName) {
                this.filterValue.set(selected.buyerName);
            }
        });

        // Update filter value when input buyerName changes
        effect(() => {
            const name = this.buyerName();
            if (name && name !== '') {
                this.filterValue.set(name);
            }
        });
    }

    // In SearchBuyerComponent
    onInputChange(value: string): void {
        this.filterValue.set(value);
        this.searchParams.set({
            ...this.searchParams(),
            buyerName: value.trim(),
        });

        if (value.trim()) {
            this.buyerService
                .searchBuyers(this.searchParams(), true)
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe({
                    next: () => {
                        this.isListVisible.set(true);
                        this.cdr.detectChanges();
                        console.log('Buyers in component after update:', this.buyers());// Force template update after signal change
                    },
                    error: (error) => {
                        console.error('Search error:', error);
                        this.isListVisible.set(false);
                    }
                });
        } else {
            this.clearSelection();
        }
    }

    onOptionSelected(buyerId: number): void {
        this.isListVisible.set(false);
        this.selectedBuyerId.emit(buyerId);

        // Find the selected buyer from the existing list and update filterValue
        const selectedBuyer = this.buyers().find(buyer => buyer.buyerId === buyerId);
        if (selectedBuyer) {
            this.filterValue.set(selectedBuyer.buyerName);
        }
    }

    @HostListener('document:click', ['$event'])
    clickOutsideDropdown(event: Event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isListVisible.set(false);
            if (!this.selectedBuyer() && this.filterValue() === '') {
                this.clearSelection();
            }
        }
    }

    clearSelection(): void {
        this.filterValue.set('');
        this.searchParams.set({
            buyerName: '',

        });
        this.buyerService.initial();
        this.selectedBuyerId.emit(-1);
    }

    selectAll(event: MouseEvent): void {
        (event.target as HTMLInputElement).select();
    }
}